// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "ee7b23a4d8d48f1bc1e4" + ".js";
};